// Default contact information for forms
export const DEFAULT_CONTACT_INFO = {
  name: 'Lina',
  phone: '+65 8512 3494',
  email: 'contact@beemascaffolding.sg'
};

// Default additional services configuration
export const DEFAULT_ADDITIONAL_SERVICES = {
  additionalTransport: { selected: true, price: 100 },
  additionalInstallation: { selected: true, price: 250 },
  stairsInstallation: { selected: true, price: 100 },
  stairsLoading: { selected: true, price: 30 },
  weeklyInspection: { selected: true, price: 100 }
};

// Default discount configuration
export const DEFAULT_DISCOUNT = {
  type: 'none',
  value: 0
};

// Default GST configuration
export const DEFAULT_GST = {
  percentage: 0
};

// Standardized payment terms for both quotations and invoices
export const PAYMENT_TERMS = {
  DEPOSIT_50: '50% deposit, balance on completion',
  FULL_PAYMENT: '100% payment due',
  CUSTOM: 'custom'
};

// Payment terms labels for display
export const PAYMENT_TERMS_LABELS = {
  [PAYMENT_TERMS.DEPOSIT_50]: '50% deposit, balance on completion',
  [PAYMENT_TERMS.FULL_PAYMENT]: '100% payment due',
  [PAYMENT_TERMS.CUSTOM]: 'Custom terms'
};

/**
 * Intelligent mapping function for backward compatibility
 * Maps stored payment terms to form values, treating non-standard terms as custom
 * @param {string} storedPaymentTerms - Payment terms stored in database
 * @param {string} storedCustomTerms - Custom payment terms stored in database
 * @returns {Object} Form values for payment terms
 */
export const mapPaymentTermsForForm = (storedPaymentTerms, storedCustomTerms) => {
  // If already marked as custom, use custom terms
  if (storedPaymentTerms === PAYMENT_TERMS.CUSTOM && storedCustomTerms) {
    return {
      paymentTerms: PAYMENT_TERMS.CUSTOM,
      customPaymentTerms: storedCustomTerms
    };
  }
  
  // Check if stored terms match any standard option
  const standardTerms = Object.values(PAYMENT_TERMS).filter(term => term !== 'custom');
  if (standardTerms.includes(storedPaymentTerms)) {
    return {
      paymentTerms: storedPaymentTerms,
      customPaymentTerms: ''
    };
  }
  
  // Everything else becomes custom (backward compatibility)
  return {
    paymentTerms: PAYMENT_TERMS.CUSTOM,
    customPaymentTerms: storedPaymentTerms || ''
  };
};
